<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nuevo Kam</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :tableFilter="tableFilter"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="30"
        :dark="dark"
        pagination
      >
        <template #provider_id="{item}"><td class="text-center w300">{{item.provider.name}}</td></template>
        <template #email="{item}"><td class="text-center w300">{{item.email}}</td></template>
        <template #user="{item}"><td class="text-center w200">{{item.user && item.user.api_token ? item.user.email : '-'}}<span v-if="item.user && item.user.api_token"><br />{{item.user.last_login | date}}<span v-if="permissions && permissions['kams.login'] === true"><br /><br /><CButton color="success" size="sm" @click="login(item)"><CIcon name="cil-https"/> Ingresar</CButton></span></span></td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <span v-if="!permissions || permissions['kams.write'] !== true">-</span>
            <CButton color="warning" size="sm" @click="updateModal(item)" v-if="permissions && permissions['kams.write'] === true"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)" v-if="permissions && permissions['kams.write'] === true"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <KamModal ref="kamModal" @store="storeProcess" @update="updateProcess"></KamModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import KamModal from './KamModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/kams';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'KamsTable',
  components: { KamModal, DeleteModal },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'provider_id', label: 'Proveedor'},
          {key: 'name', label: 'Nombre'},
          {key: 'email', label: 'Correo Electrónico'},
          {key: 'user', label: 'Acceso'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      kam_id: 0,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    showSales (item) {
      router.push({path: '/kams/'+item.id+'/'+(this.slugify(item.name))+'/sales'});
    },
    storeModal () {
      this.$refs.kamModal.storeModal();
    },
    updateModal (item) {
      this.$refs.kamModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Kam", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    login (item) {
      if(window.location.hostname != 'localhost'){
        window.location = "https://app.kpibonus.com/#/"+item.user.api_token+"/login-link";
      }
      else{
        window.location = "http://"+window.location.hostname+":"+window.location.port+"/#/"+item.user.api_token+"/login-link";
      }
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
